import React from "react";
import {
  Card,
  Typography,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useForm, SubmitHandler } from "react-hook-form";
import Grid from "@mui/material/Grid";

import Input from "components/Input";

import { useAuth } from "context/AuthContext";
import CreatePasswordModal from "components/CreatePasswordModal";
import * as Styled from "./styles";

type LoginInputs = {
  username: string;
  password: string;
};

const Login = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm<LoginInputs>();

  const { signIn, needCreateNewPassword } = useAuth();

  const onSubmit: SubmitHandler<LoginInputs> = (data) => {
    signIn(data);
  };

  return (
    <Styled.Container>
      <CreatePasswordModal
        username={getValues().username}
        password={getValues().password}
      />
      <Styled.ContainerContent>
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card
            sx={{
              maxWidth: 360,
            }}
          >
            <CardContent>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Typography
                  sx={{ fontSize: "typography.fontsize" }}
                  color="text"
                  variant="h5"
                  fontWeight={300}
                >
                  {t("loginTitle")}
                </Typography>

                <Typography
                  sx={{ mb: 2 }}
                  color="text.secondary"
                  variant="subtitle1"
                  fontWeight={300}
                  fontSize="0.875rem"
                >
                  {t("loginSubtitle")}
                </Typography>
                <Styled.ContainerFingerPrint />

                <Input
                  name="username"
                  error={errors.username}
                  label="Email"
                  register={register}
                  registerOptions={{
                    required: t("requiredField"),
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: t("invalidEmail"),
                    },
                  }}
                  fullWidth
                />

                <Input
                  name="password"
                  error={errors.password}
                  label={t("passwordLabel")}
                  register={register}
                  registerOptions={{
                    required: t("requiredField"),
                  }}
                  autoComplete={needCreateNewPassword ? "off" : "true"}
                  sx={{
                    mt: 2,
                  }}
                  type="password"
                  fullWidth
                />

                <CardActions sx={{ padding: 0 }}>
                  <Button
                    type="submit"
                    fullWidth
                    size="small"
                    variant="contained"
                    sx={{ my: 2, padding: "8px 16px", borderRadius: "4px" }}
                  >
                    {t("loginButton")}
                  </Button>
                </CardActions>
                <Styled.Account>
                  <Styled.ForgotPasswordText to="/forgot-password">
                    {t("forgotPassword")}
                  </Styled.ForgotPasswordText>
                </Styled.Account>
              </form>
            </CardContent>
          </Card>
        </Grid>
        <div>
          <Styled.ContainerBackground />
        </div>
      </Styled.ContainerContent>
    </Styled.Container>
  );
};

export default Login;
